import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { postMessageOnStudentsChat } from "../../../api/endpoints/ChatEndpoints";
import { ChatMessage, ChatType } from "../../../models/Chat";
import { postMessageOnTeacherChat } from "./../../../api/endpoints/ChatEndpoints";

export default function usePostMessageOnChat(
  chatId: string,
  chatType: ChatType,
) {
  return useMutation<ChatMessage, AxiosError, { message: string }>({
    mutationKey: ["post-message-on-chat", chatId, chatType],
    mutationFn: ({ message }) =>
      chatType === "chat-with-teacher"
        ? postMessageOnTeacherChat(chatId, message)
        : postMessageOnStudentsChat(chatId, message),
  });
}
